import { useAuth } from 'components/AuthProvider';
import Loading from 'components/Loading';
import Home from 'home/Home';
import Login from 'login/Login';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Admin from 'admin/Admin';
import LogDialogContent from 'log/LogDialogContent';

interface Props {}

export enum AppPath {
  Home = '/',
  Login = '/login',
  Admin = '/admin',
  Log = 'log',
}

export enum AppParams {
  LogId = 'logId',
  BoxId = 'id',
}

export const AppRoutes = (props: Props) => {
  const { status } = useAuth();

  if (status === 'loading') return <Loading />;

  return (
    <Routes>
      <Route path={AppPath.Login} element={<Login />} />
      <Route path={AppPath.Admin} element={<Admin />} />
      <Route path={AppPath.Home} element={<Home />}>
        <Route
          path={`${AppPath.Log}/:${AppParams.LogId}`}
          element={<LogDialogContent />}
        />
      </Route>
      <Route path="*" element={<div>ページが見つかりません</div>} />
    </Routes>
  );
};

export default AppRoutes;
